module.exports = __webpack_public_path__ + "static/media/shipping.42e80d94.svg";